import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
  fetchDownlines,
  fetchDownlinesSuccess,
  fetchDownlinesFailure,
  getDownline,
  getDownlineSuccess,
  getDownlineFailure,
  addInvitation,
  addInvitationSuccess,
  addInvitationFailure
} from "./downline.actions";
import { of} from "rxjs";
import { map, mergeMap, catchError, tap} from "rxjs/operators";
import { PageService, DownlineService } from '@services/index';

@Injectable()
export class DownlinesEffects {
  loadDownlines$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchDownlines),
      mergeMap(action =>
        this.downlineService.getDownlines(action.page, action.filterOptions).pipe(
          map(res => {
            return fetchDownlinesSuccess({ downlines: res });
          }),
          catchError(error => {
            return of(fetchDownlinesFailure({ error }));
          })
        )
      )
    )
  );

  loadDownline$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getDownline),
      mergeMap(action =>
        this.downlineService.getDownline(action.downlineID).pipe(
          map(res => {
            return getDownlineSuccess({ downline: res });
          }),
          catchError(error => {
            return of(getDownlineFailure({ error }));
          })
        )
      )
    )
  );

  addInvitation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addInvitation),
      mergeMap(action =>
        this.downlineService.insertInvitation(action.invitation).pipe(
          map(invitation => {
            return addInvitationSuccess({ invitation });
          }),
          tap(() => {
            this.pageService.onNotificationToggle({ show: true, error: false, message: 'Invitation Sended Successfully!' });
          }),
          catchError(error => {
            this.pageService.onNotificationToggle({ show: true, error: true, message: 'Something Went Wrong!' });
            return of(addInvitationFailure({ error }));
          })
        )
      )
    )
);

  constructor(
    private pageService: PageService,
    private actions$: Actions,
    private downlineService: DownlineService
  ) {}
}
